module.exports = __webpack_public_path__ + "img/xmlb.cc671d17.jpg";